<div class="flex flex-col w-full h-dvh min-h-0">
    <div class="h-1.5 sm:h-2"
        [ngStyle]="{
            'background-color': settingTheme?.menuBackgroundColour
        }">
    </div>
    <!-- Reserve the scrollbar only while the header scrolls. Calendar sticky bars are 100vw minus that width. -->
    <div class="flex flex-col flex-1 min-w-0 min-h-0 overflow-y-auto"
        [ngClass]="{
            'overflow-x-auto': headerScrolls,
            'overflow-x-hidden sm:overflow-x-auto': !headerScrolls
        }"
        [ngStyle]="{
            'scrollbar-gutter': headerScrolls ? 'stable' : null
        }">
        <!-- That gutter narrows this bar. Trim the right padding by it so these top navigation items line up with pages where the header stays pinned. -->
        <div class="flex items-center justify-between w-full h-12 min-w-0 px-2 bg-white shadow z-49 shrink-0 sm:pl-5 sm:h-15"
            [ngClass]="{
                'sm:pr-5': !headerScrolls,
                'sm:pr-[calc(1.25rem-(100vw-100%))]': headerScrolls,
                'sticky top-0 left-0': !headerScrolls,
                'sticky left-0': headerScrolls
            }">
            @if (isScreenSmall) {
                <button mat-icon-button (click)="toggleNavigation('mainNavigation')" aria-label="Toggle navigation menu">
                    <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
                </button>
            }
            @if (!isScreenSmall) {
                <a [routerLink]="['/']" class="flex items-center flex-shrink-0 w-32 h-8 sm:h-10">
                    @if (settingTheme) {
                        <img class="object-contain object-left max-w-full max-h-8 sm:max-h-10" [src]="settingTheme.logo">
                    }
                </a>
                @if (navigation) {
                    <fuse-horizontal-navigation
                        [name]="'mainNavigation'"
                        [navigation]="navigation.navigationByRole">
                    </fuse-horizontal-navigation>
                }
            }
            <div class="flex items-center gap-1">
                <outstanding-actions></outstanding-actions>
                <user></user>
            </div>
        </div>
        <router-outlet></router-outlet>
    </div>
</div>

@if (isScreenSmall && navigation) {
    <fuse-vertical-navigation
        class="bg-gray-900 dark"
        [mode]="'over'"
        [name]="'mainNavigation'"
        [navigation]="navigation.navigationByRole"
        [opened]="false">
        <ng-container fuseVerticalNavigationContentHeader>
            @if (settingTheme) {
                <div class="flex items-center h-20 px-8 pt-6">
                    <a [routerLink]="['/']">
                        <img class="object-contain w-auto ml-2 max-h-8 sm:max-h-10" [src]="settingTheme.logo">
                    </a>
                </div>
            }
        </ng-container>
    </fuse-vertical-navigation>
}
